import { Component, ViewChild, TemplateRef, ElementRef, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PaginationService } from 'src/app/PaginationService';
import { DynamicAuditTrailComponent } from '../support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from '../support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from '../grid-reorder/grid-reorder.component';

export interface QmsReportTemplateInterface {
  qmsReportTemplateVwPk: {
    templateId: number;
  };
  createdBy: number;
  updatedOn: Date;
  updatedBy: number;
  createdByUser: string;
  updatedByUser: string;
  module: string;
  templateName: string;
  reportName: string;
  groupIds: string;
  isDefault: boolean;
  isActive: boolean;
  isFactoryTemplate: boolean;
  createdOn: Date;
  userId: number;
  operation: string;
  deleteReason: string;
}

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-qms-report-template',
  templateUrl: './qms-report-template.component.html',
  styleUrls: ['./qms-report-template.component.scss']
})

export class QmsReportTemplateComponent implements OnInit {

  snackbarRef: any;
  isProcessing = true;
  _temp: any = {};
  columnLists: any = {};
  qmsReportTemplateDataForGrid: any = [];
  qmsReportTemplateDataForGridTemp: any;
  makeStickyColumns: any;
  dataTypeList: any = [];
  selectedGroups: any;
  auditTrail: any = {};
  visibleAuditTrail: boolean = false;
  oddModule: any = null;
  typeSearchText: any;
  groupDropdown: any = [];
  listOfGroups: any = [];
  groupIdsValues: any = [];
  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef) {
    this.message.breadcrumbData.fourthLevel = '';
  }

  dropDownDataForModule: any = [];
  ngOnInit() {
    this.getcallMethod();
    this.dropDownDataForModule = JSON.parse(sessionStorage.getItem('dropDownForModules') || '{}');
    this.selectBoxForModule();
  }

  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private readonly users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.qmsReportTemplateDataForGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.qmsReportTemplateDataForGrid
      .slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  setPagedorserch(page: number, targetpage: number) {

    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.qmsReportTemplateDataForGridTemp?.length > 0) {
      this.pager = this.paginationService.getPager(this.qmsReportTemplateDataForGridTemp.length, page, this.perPage, targetpage);
      this.pagedItems = this.qmsReportTemplateDataForGridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  focusEmpty() {
    console.log();
  }

  getcallMethod() {
    this.qmsReportTemplateDataForGrid = [];
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    const data = {

      gridName: "REPORT_TEMPLATE"
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause ??= "";

        this.makeStickyColumns = response.fixedFieldCnt;

        const data1: any = {

          gridName: "QMS_REPORT_TEMPLATE_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }
        this.reportObj = { ...data1, ...data };
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.qmsReportTemplateDataForGrid = response1;
            this.visibleAuditTrail = false;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            let rendereddata: any;
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const size of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(size + 'px');
            }

            let y = 0;
            for (const column of this.columnLists.columnsListarray) {

              for (const invisibleColumn of this.columnLists.invisibleColumnarray) {
                if (column == invisibleColumn) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }

              y++;
            }

            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const dataType of this.dataTypeList) {
                  if (dataType.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = dataType.fieldType;
                  }
                }
              }
              for (const qmsReportTemplate of this.qmsReportTemplateDataForGrid) {

                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType == 'CHECKBOX') {
                    qmsReportTemplate[dataType.columnName] = qmsReportTemplate[dataType.columnName] == 'Y';
                  }
                }

              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.qmsReportTemplateDataForGrid;
            this.collectionSize = this.qmsReportTemplateDataForGrid.length;
            this.totalPages = Math.ceil(this.qmsReportTemplateDataForGrid.length / this.itemsPerPage);
            this.dynamicLabelCall();
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.qmsReportTemplateDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.qmsReportTemplateDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  searchValue: any;
  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.qmsReportTemplateDataForGridTemp = this.qmsReportTemplateDataForGrid;
      this.pager = this.paginationService.getPager(this.qmsReportTemplateDataForGridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.qmsReportTemplateDataForGridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {

      if (this.qmsReportTemplateDataForGrid == undefined) {
        return this.qmsReportTemplateDataForGrid;
      }
      if (!this.qmsReportTemplateDataForGrid.length) {
        return this.qmsReportTemplateDataForGrid;
      }
      if (filter) {
        this.qmsReportTemplateDataForGridTemp = this.qmsReportTemplateDataForGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });

      } else {
        this.qmsReportTemplateDataForGridTemp = this.qmsReportTemplateDataForGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedorserch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.qmsReportTemplateDataForGrid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

    this.snackbarRef?.dismiss?.();
    let templateName = event.target.innerText;
    let filtedQmsReportTemplateData = this.qmsReportTemplateDataForGrid.filter((x: any) => x.TEMPLATE_NAME === templateName);
    if (filtedQmsReportTemplateData.length > 0 && this.message.templateIdFromQmsReportTemplate == null) {
      this.message.templateIdFromQmsReportTemplate = filtedQmsReportTemplateData[0].TEMPLATE_ID;
      console.log("==1=", filtedQmsReportTemplateData[0].GROUP_NAMES);
      this.message.groupNameFromQmsReportTemplate = filtedQmsReportTemplateData[0].GROUP_NAMES;
      this.router.navigate(['dashboard/qmsReportTemplateSectionField']);
    }
  }

  detailsData(list: any, index: number) {
    if (index === 0) {
      const matchedTemplate = this.qmsReportTemplateDataForGrid.find((x: any) => x.TEMPLATE_NAME === list.TEMPLATE_NAME);

      if (matchedTemplate) {
        this.message.templateIdFromQmsReportTemplate = matchedTemplate.TEMPLATE_ID;
        console.log("==1=", matchedTemplate.GROUP_NAMES);
        this.message.groupNameFromQmsReportTemplate = matchedTemplate.GROUP_NAMES;
        this.message.moduleFromQmsReportTemplate = matchedTemplate.MODULE;
        this.message.subModule = matchedTemplate.SUB_MODULE;
        this.message.navigatedReportTemplateName = list.TEMPLATE_NAME;

        this.router.navigate(['dashboard/qmsReportTemplateSectionField']);
      }
    }
  }
  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  dataGridParentCheckBoxChecked(e: any) {
    const isChecked = e.target.checked;

    this.childCheckBoxs = isChecked;

    for (const reportTemplate of this.qmsReportTemplateDataForGrid) {
      reportTemplate.childCheckBoxs = isChecked;
    }
  }

  priviousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.priviousSelectedValue != undefined) {
        this.qmsReportTemplateDataForGrid[this.priviousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.TEMPLATE_ID;
    } else {
      list.childCheckBoxs = false;
    }
    this.priviousSelectedValue = idx;
    this.visibleAuditTrail = this.qmsReportTemplateDataForGrid.some((list: any) => list.childCheckBoxs);
  }


  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
  };

  selectedModule: any = null;
  moduleListDropdown: any = [];
  selectBoxForModule() {
    this.moduleListDropdown = [];
    for (const moduleData of this.dropDownDataForModule) {
      this.moduleListDropdown = this.moduleListDropdown.concat({
        valueExp: moduleData.codelistCode,
        displayExp: moduleData.codelistName
      });
    }
  }
  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  modulesearchTxt: any;

  onModuleSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (item) {
          this.selectedModule = item.valueExp;
        }
      } else {
        this.selectedModule = undefined;
      }
      this.qmsReportTemplateFieldData.groupIds = null;
      this.groupDropdown = [];
      this.groupIdsValues = [];
      this.appService.getQmsGroupsByModule(item.valueExp).subscribe((data: any) => {
        this.listOfGroups = data;
        this.selectBoxeForGroupValue();
      })
    }
  }
  selectBoxeForGroupValue() {
    this.groupDropdown = [];
    for (const group of this.listOfGroups) {
      this.groupDropdown = this.groupDropdown.concat({
        valueExp: group.groupId,
        displayExp: group.groupName
      });
    }

  }
  refreshGridData() {
    this.isProcessing = true;
    setTimeout(() => {
      this.getcallMethod();
    }, 0);
  }

  qmsReportTemplateFieldData: any = {};
  operationFlag: any;
  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  visibleReasonForUpdateField: boolean;

  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.visibleReasonForUpdateField = false;
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = "Create QMS Report Template";
    this.selectedModule = null;
    this.qmsReportTemplateFieldData.templateName = '';
    this.qmsReportTemplateFieldData.groupIds = '';
    this.qmsReportTemplateFieldData.reportName = '';
    this.qmsReportTemplateFieldData.isDefault = false;
    this.qmsReportTemplateFieldData.isActive = true;
    this.qmsReportTemplateFieldData.isFactoryTemplate = false;
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  previousData: any;
  previousDataTemplateId: any;
  getQmsReportTemplateVwDetailsData: any = [];
  filteredModuleValue: any = [];
  openEditPopup(qmsReportTemplateRowData: any) {
    this.isProcessing = true;
    this.previousData = qmsReportTemplateRowData;
    this.visibleAddButton = false;
    this.qmsReportTemplateFieldData.updateReason = null;
    this.visibleEditButton = true;
    this.visibleReasonForUpdateField = true;
    this.operationFlag = 'EDIT';
    this.popupDataTitle.title = "Update QMS Report Template";
    this.previousDataTemplateId = qmsReportTemplateRowData.TEMPLATE_ID;
    this.appService.getQmsReportTemplateDetailsByOrgIdAndTemplateId(this.previousDataTemplateId).subscribe((response: any) => {
      this.getQmsReportTemplateVwDetailsData = response
      this.qmsReportTemplateFieldData.templateId = this.getQmsReportTemplateVwDetailsData.qmsReportTemplateVwPk.templateId;
      this.qmsReportTemplateFieldData.templateName = this.getQmsReportTemplateVwDetailsData.templateName;
      this.qmsReportTemplateFieldData.groupIds = this.getQmsReportTemplateVwDetailsData.groupIds ?? null;
      this.qmsReportTemplateFieldData.reportName = this.getQmsReportTemplateVwDetailsData.reportName;
      this.qmsReportTemplateFieldData.isDefault = this.getQmsReportTemplateVwDetailsData.isDefault == 'Y';
      this.qmsReportTemplateFieldData.isActive = this.getQmsReportTemplateVwDetailsData.isActive == 'Y';
      this.qmsReportTemplateFieldData.isFactoryTemplate = this.getQmsReportTemplateVwDetailsData.isFactoryTemplate == 'Y';

      if (this.getQmsReportTemplateVwDetailsData.module) {
        const matchingModule = this.dropDownDataForModule?.find((item: any) => item.codelistCode == this.getQmsReportTemplateVwDetailsData.module);
        if (!matchingModule) {
          this.oddModule = this.getQmsReportTemplateVwDetailsData.module;
          this.moduleListDropdown.push({
            valueExp: this.getQmsReportTemplateVwDetailsData.module,
            displayExp: this.getQmsReportTemplateVwDetailsData.module
          })
        }
        this.selectedModule = this.getQmsReportTemplateVwDetailsData.module;
        this.appService.getQmsGroupsByModule(this.selectedModule).subscribe((data: any) => {
          this.listOfGroups = data;
          this.groupDropdown = [];
          for (const group of this.listOfGroups) {
            this.groupDropdown = this.groupDropdown.concat({
              valueExp: group.groupId,
              displayExp: group.groupName
            });
          }
          this.groupIdsValues = this.getQmsReportTemplateVwDetailsData.groupIds ? this.getQmsReportTemplateVwDetailsData.groupIds.split(",").map(Number) : null;
          console.log(this.groupIdsValues);
          this.isProcessing = false;
          this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
        })
      }
    })
  }

  moduleValue: any;
  templateNameValue: any;
  reportNameValue: any;
  updateReason: any;

  moduleValueRequiredMsg: any;
  templateNameValueRequiredMsg: any;
  reportNameValueRequiredMsg: any;
  updateReasonRequiredMsg: any;

  fieldValidation() {
    this.moduleValue = document.getElementById('module') as HTMLInputElement;
    this.templateNameValue = document.getElementById('tempalteName') as HTMLInputElement;
    this.reportNameValue = document.getElementById('reportName') as HTMLInputElement;
    this.updateReason = document.getElementById('updateReason') as HTMLInputElement;

    this.moduleValueRequiredMsg = document.getElementById('module-required-msg') as HTMLInputElement;
    this.templateNameValueRequiredMsg = document.getElementById('templateName-required-msg') as HTMLInputElement;
    this.reportNameValueRequiredMsg = document.getElementById('reportName-required-msg') as HTMLInputElement;
    this.updateReasonRequiredMsg = document.getElementById('updateReason-required-msg') as HTMLInputElement;
    if (this.selectedModule) {
      this.moduleValue.style.border = 'none';
      this.moduleValueRequiredMsg.style.display = 'none';
    } else {
      this.moduleValue.style.border = '1px solid red';
      this.moduleValueRequiredMsg.style.display = 'block';
    }

    if (this.templateNameValue.value == "" || this.templateNameValue.value == null || this.templateNameValue.value == undefined) {
      this.templateNameValue.style.border = '1px solid red';
      this.templateNameValueRequiredMsg.style.display = 'block';
    } else {
      this.templateNameValue.style.border = 'none';
      this.templateNameValueRequiredMsg.style.display = 'none';
    }

    if (this.reportNameValue.value == "" || this.reportNameValue.value == null || this.reportNameValue.value == undefined) {
      this.reportNameValue.style.border = '1px solid red';
      this.reportNameValueRequiredMsg.style.display = 'block';
    } else {
      this.reportNameValue.style.border = 'none';
      this.reportNameValueRequiredMsg.style.display = 'none';
    }

    if (this.operationFlag == 'EDIT') {
      if (this.qmsReportTemplateDataForGrid.updateReason == null) {
        this.updateReason.style.border = '1px solid red';
        this.updateReasonRequiredMsg.style.display = 'block';
      } else {
        this.updateReason.style.border = 'none';
        this.updateReasonRequiredMsg.style.display = 'none';
      }
    }
  }


  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;
  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  addAndEditFunction(qmsReportTemplateFieldData: any) {
    this.isProcessing = true;
    if (!this.selectedModule ||
      (qmsReportTemplateFieldData.templateName == "" || qmsReportTemplateFieldData.templateName == null || qmsReportTemplateFieldData.templateName == undefined) ||
      (qmsReportTemplateFieldData.reportName == "" || qmsReportTemplateFieldData.reportName == null || qmsReportTemplateFieldData.reportName == undefined)) {
      this.fieldValidation();
      this.isProcessing = false;
    } else {

      if (this.groupIdsValues) {
        this.qmsReportTemplateFieldData.groupIds = null;
        for (const [index, groupId] of this.groupIdsValues.entries()) {
          this.qmsReportTemplateFieldData.groupIds += groupId;
          this.qmsReportTemplateFieldData.groupIds += index === this.groupIdsValues.length - 1 ? "" : ",";
        }
      } else {
        this.qmsReportTemplateFieldData.groupIds = null;
      }
      let data = {
        templateName: qmsReportTemplateFieldData.templateName ?? null,
        groupIds: qmsReportTemplateFieldData.isFactoryTemplate ? null : qmsReportTemplateFieldData.groupIds,
        reportName: qmsReportTemplateFieldData.reportName,
        isDefault: qmsReportTemplateFieldData.isDefault ? "Y" : "N",
        isActive: qmsReportTemplateFieldData.isActive ? "Y" : "N",
        isFactoryTemplate: qmsReportTemplateFieldData.isFactoryTemplate ? "Y" : "N",
        module: this.selectedModule ?? null
      }
      if (this.operationFlag == 'ADD') {
        this.appService.createQmsReportTemplateVwDetails(data).subscribe({
          next: (Response: any) => {
            this.displayMessage = Response.result;
            this.displayResultType = Response.resultType;
            if (this.displayResultType == 'S') {
              this.visibleAddAndEditPopup.close();
              this.ngOnInit();
            }
            this.isProcessing = false;
            this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: this.displayResultType == 'S' ? 5000 : undefined,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            this.snackbarRef.onAction().subscribe(() => {
              this.snackbarRef.dismiss();
            });
          }, error: (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          }
        });
      } else {
        if (this.qmsReportTemplateFieldData.updateReason == null) {
          this.fieldValidation();
          this.isProcessing = false;
        } else {
          delete qmsReportTemplateFieldData.createdOn;
          delete qmsReportTemplateFieldData.updatedOn;

          let modifiedData = {
            ...data,
            updateReason: qmsReportTemplateFieldData.updateReason,
            qmsReportTemplateVwPk: {
              templateId: this.previousDataTemplateId
            }
          }
          this.appService.updateQmsReportTemplateVwDetails(modifiedData).subscribe({
            next: (Response: any) => {
              this.displayMessage = Response.result;
              this.displayResultType = Response.resultType;
              if (this.displayResultType == 'S') {
                this.visibleAddAndEditPopup.close();
                this.ngOnInit();
              }
              this.isProcessing = false;
              this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                duration: this.displayResultType == 'S' ? 5000 : undefined,
                data: {
                  message: Response.result,
                  type: Response.resultType == 'S' ? 'Success' : 'Error',
                  buttonLabel: "Ok",
                  pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
                },
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
              });
              this.snackbarRef.onAction().subscribe(() => {
                this.snackbarRef.dismiss();
              });
            }, error: (error) => {
              this.displayMessage = error;
              this.displaySuccessMessage = false;
              this.displayErrorMessage = true;
              this.isProcessing = false;
              throw error;
            }
          });
        }
      }
    }
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteFiledValueRequiredMsg: any;
  deleteValidation() {
    this.deleteFiledValueRequiredMsg = document.getElementById('deleteTextarea-required-msg') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.isProcessing = false;
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }

  deleteQmsReportTemplateId: any;
  openDeletePopup(deleteRowData: any) {
    console.log(deleteRowData);
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete QMS Report Template";
    this.deleteQmsReportTemplateId = deleteRowData.TEMPLATE_ID;
    if (this.qmsReportTemplateFieldData.deleteReason != undefined) {
      this.qmsReportTemplateFieldData.deleteReason = '';
    }
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteFiledValue: any;
  deleteFunction(qmsReportTemplateFieldData: any) {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteValidation();
      this.isProcessing = false;
    } else {
      qmsReportTemplateFieldData.qmsReportTemplateVwPk = {
        templateId: this.deleteQmsReportTemplateId
      };
      qmsReportTemplateFieldData.deleteReason = this.qmsReportTemplateFieldData.deleteReason;
      this.appService.deleteQmsReportTemplateVwDetails(qmsReportTemplateFieldData).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.visibleDeletePopup.close();
            this.ngOnInit();
          }
          this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: this.displayResultType == 'S' ? 5000 : undefined,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          this.snackbarRef.onAction().subscribe(() => {
            this.snackbarRef.dismiss();
          });
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  @ViewChild('copyPopup', { static: true }) copyPopup: TemplateRef<any>;
  visibleCopyPopup: MatDialogRef<TemplateRef<any>>;
  copyPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  copyTemplateData: any = {};
  copyPopupFunc(data: any) {
    this.copyTemplateData = {};
    this.copyTemplateData.targetTemplateName = "";
    this.copyTemplateData.sourceTemplateId = data.TEMPLATE_ID;
    this.visibleCopyPopup = this.dialog.open(this.copyPopup, this.copyPopupConfig);
  }
  documentTypeNameCopyValue: any;
  documentTypeNameCopyRequiredMsg: any;
  fieldValidationForCopy() {
    this.documentTypeNameCopyValue = document.getElementById('documentTypeNameForCopy') as HTMLInputElement;
    this.documentTypeNameCopyRequiredMsg = document.getElementById('documentTypeNameForCopy-required-msg') as HTMLInputElement;



    if (this.documentTypeNameCopyValue.value) {
      this.documentTypeNameCopyValue.style.border = 'none';
      this.documentTypeNameCopyRequiredMsg.style.display = 'none';
    } else {
      this.documentTypeNameCopyValue.style.border = '1px solid red';
      this.documentTypeNameCopyRequiredMsg.style.display = 'block';
    }

  }
  copyFunction() {
    this.isProcessing = true;
    if (this.copyTemplateData.documentTypeName == "") {
      this.fieldValidationForCopy();
      this.isProcessing = false;
    } else {
      this.appService.getCallCopyQmsReportTemplateProcedure(this.copyTemplateData).subscribe({
        next: (data: any) => {
          if (data.resultType == "S") {
            this.isProcessing = false;
            this.visibleCopyPopup.close();
            this.getcallMethod();
          }
          this.isProcessing = false;
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: data.resultType == 'S' ? 5000 : undefined,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",
              pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;

        }, error: (error) => {

          this.isProcessing = false;
          throw error;
        }
      });
    }
  }
  cancelCopyFunction() {
    this.visibleCopyPopup.close();
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, notification: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : notification.TEMPLATE_ID;
    this.auditTrail.gridName = 'REPORT_TEMPLATE';
    this.auditTrail.report_And_Popup_Name = 'QMS Report Template Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(notification);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Report Template Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };

  dynamicLabel: any = null;
  label: any = [];
  dynamicLabelCall() {
    this.isProcessing = true;
    const data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }
  onGroupIdsSelect(event: any, item: any) {
    if (event.isUserInput) {
      console.log(item.valueExp);

    }
  }
}
